import React, { Component } from 'react';

class Footer extends Component {
    render() {
        return (
            <footer className="footer">
                &copy; {new Date().getFullYear()} Marines Event Management.
            </footer>
        );
    }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer/index.js